import React, { useState, useEffect } from "react";
import BarberSubsLogin from "./BarberSubsComps/BarberSubsLogin";
import BarberSubsMainPage from "./BarberSubsComps/BarberSubsMainPage";

export default function BarberSubs() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if admin exists in localStorage
    const barberSubs = localStorage.getItem("barber");
    if (barberSubs) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  return (
    <div>
      {isLoggedIn ? (
        <>
          <BarberSubsMainPage />
        </>
      ) : (
        <BarberSubsLogin />
      )}
    </div>
  );
}
